import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getPODData, PODDataModel, PODParameter } from "@WhiteCap/Store/Service/PODService";

type HandlerType = CustomApiHandler<PODParameter, PODDataModel>;

export const DispatchBeginPODData: HandlerType = props => {
    props.dispatch({
        type: "Custom/PODData/BeginLoadPODData",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPODData(props.apiParameter);
};

export const DispatchCompleteCreditMemo: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/PODData/CompletedLoadPODData",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginPODData, PopulateApiParameter, RequestDataFromApi, DispatchCompleteCreditMemo];

const loadPODData = createHandlerChainRunner(chain, "LoadPODData");
export default loadPODData;
